import { setNumberOfEmployees } from "@features/planSlice";
import { setCompanyName, setContactNumber, setEmailAddress, setEmployeeName } from "@features/userSlice";

export const initialState = {
    employeeName: {
        error: null,
        value:"John Doe",
        inactive:true,
        regEx: /[a-zA-Z ]{3,}$/,
        uiLabel: "Name",
        action: setEmployeeName,
    },
    companyName: {
        error: null,
        value:"",
        inactive:true,
        regEx: /[a-zA-Z ]{2,}$/,
        uiLabel: "Company Name",
        action: setCompanyName,
    },
    email: {
        error: null,
        value:"john@loop.com",
        inactive:true,
        regEx:
            //eslint-disable-next-line
            /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i,
        uiLabel: "Email address",
        action: setEmailAddress,
    },
    phone: {
        error: null,
        value:"9865378303",
        inactive:true,
        regEx: /^[6-9][0-9]{9}$/,
        uiLabel: "Phone number",
        action: setContactNumber,
    },
    numberOfEmployees: {
        error: null,
        value:"",
        inactive:true,
        regEx: /[0-9]/,
        uiLabel: "Number of employees",
        action: setNumberOfEmployees,
    },
}